/**
 * @file 前后端接口加密
 * @author quda
 */
import md5js from 'crypto-js/md5.js';
import {signConfig} from '../constant/sign.config';

/**
  * 根据对象key进行排序
  * @param {Object} obj - 目标对象
  * @return {Object} - 排序后的对象
  */
export const ksort = obj => {
    const keys = Object.keys(obj).sort();
    const sortedObj = {};
    for (let i = 0; i < keys.length; i++) {
        sortedObj[keys[i]] = obj[keys[i]];
    }

    return sortedObj;
};

/**
  * 基于接口配置对接口参数进行过滤
  * @param {Object} obj
  */
export const filterProps = obj => {
    const filter = signConfig[obj.qt];
    const filtedObj = {};
    if (filter && filter.length > 0) {
        for (let key in obj) {
            if (filter.indexOf(key) > -1) {
                filtedObj[key] = obj[key];
            }
        }
        return filtedObj;
    }
    return obj;
};

/**
  * 计算sign
  * @param {Object} param - 对象集合
  * @param {string} salt - 盐值
  * @return {string} md5 sign
  */
export function makeSign(param, salt) {
    const p = ksort(filterProps(param));
    const arr = [];

    for (let key in p) {
        if (Object.prototype.hasOwnProperty.call(p, key)) {
            // 默认不转码，如需转码在入参中处理
            arr.push(`${key}=${p[key]}`);
        }
    }
    const str = arr.join('&') + salt;

    return md5js(str).toString();
}
